import { FIELD_TYPE } from "types/enums";
import { DataFormField } from "types/models/input-field-type";
const { INPUT, SELECT, DATE, COMBO_BOX, NUMBER, CODE, INPUT_NUMBER } =
  FIELD_TYPE;

const dataField = () => {
  const dataField: DataFormField[] = [
    {
      type: INPUT,
      label: "Mã phiếu khám",
      placeholder: "Nhập...",
      name: "idPhieuKham",
      expand: false,
    },
    {
      type: INPUT,
      label: "Mã bệnh nhân",
      placeholder: "Nhập...",
      name: "idBenhNhan",
      expand: false,
    },

    {
      type: INPUT,
      label: "Họ tên",
      placeholder: "Nhập",
      name: "hoTenBN",
      expand: false,
    },
    {
      type: DATE,
      label: "Ngày sinh",
      placeholder: "Nhập",
      expand: false,
      name: "ngaySinh",
    },
    {
      type: COMBO_BOX,
      label: "Phòng",
      expand: false,
      name: "idPhong",
      options: JSON.parse(localStorage.getItem("phongKhamNoPeople")) || [],
    },
    {
      type: COMBO_BOX,
      label: "Giới tính",
      name: "gioiTinh",
      options: [
        { value: 0, label: "Nam" },
        { value: 1, label: "Nữ" },
      ],
      expand: true,
    },
    {
      type: INPUT,
      label: "Số thẻ BHYT",
      placeholder: "Nhập...",
      name: "baoHiem",
      expand: true,
    },
    {
      type: COMBO_BOX,
      label: "Trạng thái BH",
      placeholder: "Chọn",
      name: "trangThaiBH",
      expand: false,
      options: JSON.parse(localStorage.getItem("TTBH")) || [],
    },
    {
      type: INPUT,
      label: "Số điện thoại",
      placeholder: "Nhập...",
      name: "phoneNumber",
      expand: true,
      rules: [
        {
          pattern: new RegExp(/[0-9]/),
          message: "Đầu vào phải là số",
        },
      ],
    },
    {
      type: INPUT,
      label: "Họ tên NV",
      placeholder: "Nhập...",
      name: "hoTenNV",
      expand: true,
    },
    {
      type: INPUT,
      label: "Người thực hiện",
      placeholder: "Nhập...",
      name: "tenBsThucHien",
      expand: true,
    },
    {
      type: COMBO_BOX,
      label: "Loại KCB",
      placeholder: "Chọn",
      name: "loaiThamKham",
      expand: false,
      options: JSON.parse(localStorage.getItem("loaiKCB")) || [],
    },
    {
      type: DATE,
      label: "Ngày tạo từ",
      placeholder: "DD/MM/YY",
      name: "ngayTaoTu",
      expand: false,
      disableDate: false,
    },
    {
      type: DATE,
      label: "Ngày tạo đến",
      placeholder: "DD/MM/YY",
      name: "ngayTaoDen",
      disableDate: false,
      expand: false,
    },
    {
      type: COMBO_BOX,
      label: "Trạng thái KKX",
      placeholder: "Nhập",
      name: "status",
      expand: true,
      options: JSON.parse(localStorage.getItem("TTPhieu")) || [],
    },
    {
      type: COMBO_BOX,
      label: "Khu KCB",
      placeholder: "Chọn",
      name: "khuKham",
      expand: true,
      options: JSON.parse(localStorage.getItem("khuKham")) || [],
    },
  ];

  return dataField;
};

export default dataField;
